import { useQuery, useMutation } from '@tanstack/react-query';
import { creditsService } from '@/services/credits.service';

export function useCreditBalance() {
  return useQuery({
    queryKey: ['credits', 'balance'],
    queryFn: () => creditsService.getBalance(),
    // Auto-refetch so the sidebar/dashboard reflect deductions without a manual reload
    refetchInterval: 15_000,
    refetchOnWindowFocus: true,
  });
}

export function useCreditTransactions(page = 1, perPage = 10) {
  return useQuery({
    queryKey: ['credits', 'transactions', page, perPage],
    queryFn: () => creditsService.getTransactions(page, perPage),
  });
}

export function useJobCosts() {
  return useQuery({
    queryKey: ['credits', 'jobs'],
    queryFn: () => creditsService.getJobCosts(),
  });
}

export function useTopup() {
  return useMutation({
    mutationFn: (pkg: string) => creditsService.topup(pkg),
    onSuccess: (data) => {
      window.location.href = data.checkout_url;
    },
  });
}

export function useBatchCheckout() {
  return useMutation({
    mutationFn: ({ contacts, options }: { contacts: number; options: string[] }) =>
      creditsService.batchCheckout(contacts, options),
    onSuccess: (data) => {
      window.location.href = data.checkout_url;
    },
  });
}
